import React, { Fragment, ReactNode } from "react";
import SynerpaLayout from "../../components/SynerpaSpace/SynerpaLayout/SynerpaLayout";

function SynerpaSpace() {
    return <Fragment></Fragment>;
}

SynerpaSpace.getLayout = (page: ReactNode) => (
    <SynerpaLayout>{page}</SynerpaLayout>
);

export default SynerpaSpace;
